interface SeoStructureDataProps {
  seoStructuredData: any
}

export function SeoStructureData({ seoStructuredData }: SeoStructureDataProps) {
  const organizationData = seoStructuredData?.organization
  const websiteData = seoStructuredData?.website
  const softwareApplicationData = seoStructuredData?.softwareApplication
  const videosData = seoStructuredData?.videos
  const itemsListData = seoStructuredData?.itemsList
  const faqData = seoStructuredData?.faq
  return (
    <span key="seoStructuredData">
      {organizationData?.length > 1 && (
        <script
          id="organization"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: organizationData }}
        />
      )}
      {websiteData?.length > 1 && (
        <script
          id="website"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: websiteData }}
        />
      )}
      {softwareApplicationData?.length > 1 && (
        <script
          id="application"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: softwareApplicationData }}
        />
      )}
      {faqData?.length > 1 && (
        <script id="faq" type="application/ld+json" dangerouslySetInnerHTML={{ __html: faqData }} />
      )}
      {videosData?.length > 1 && (
        <script
          id="videoData"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: videosData }}
        />
      )}
      {itemsListData?.length > 1 && (
        <script
          id="itemsList"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: itemsListData }}
        />
      )}
    </span>
  )
}
